import clsx from "clsx";
import { makeStyles } from "tss-react/mui";

import { Box, BoxProps } from "@mui/material";

const pageContentWidths = {
    compact: 1024,
    medium: 800,
    large: 1000,
    wide: 1100,
    xlarge: 1200,
} as const;

export type PageContentWidth = keyof typeof pageContentWidths;

type PageContentWrapperProps = BoxProps & {
    size?: PageContentWidth;
    children: React.ReactNode;
};

const useStyles = makeStyles<{ maxWidth: number }>()((_theme, { maxWidth }) => ({
    wrapper: {
        maxWidth,
        width: "100%",
        margin: "0 auto",
        minWidth: 0,
    },
}));

export const PageContentWrapper = ({ size = "medium", children, className, ...boxProps }: PageContentWrapperProps) => {
    const maxWidth = pageContentWidths[size];
    const { classes } = useStyles({ maxWidth });

    return (
        <Box className={clsx(classes.wrapper, className)} {...boxProps}>
            {children}
        </Box>
    );
};
